<ng-container *transloco="let t; prefix: 'dsaManagement.infrastructure.discoveryForm'">
  <h2 mat-dialog-title class="form-dialog__title">
    {{ isEdit ? t('editTitle') : t('addTitle') }}
  </h2>

  <mat-dialog-content class="form-dialog__content">
    <p class="form-dialog__hint">{{ t('lifecycleHint') }}</p>

    <htx-form-section [formGroup]="form">
      <htx-text-field-with-error
        [ctrl]="form.controls.bpnl"
        [label]="t('bpnl')"
        [errorMessages]="errorMessagesService.messages()"
      ></htx-text-field-with-error>

      <htx-text-field-with-error
        [ctrl]="form.controls.organizationName"
        [label]="t('organizationName')"
        [errorMessages]="errorMessagesService.messages()"
      ></htx-text-field-with-error>

      <htx-text-field-with-error
        [ctrl]="form.controls.connectorUrl"
        [label]="t('connectorUrl')"
        [errorMessages]="errorMessagesService.messages()"
      ></htx-text-field-with-error>

      <htx-dropdown-field-with-error
        [ctrl]="form.controls.useCases"
        [label]="t('useCases')"
        [options]="useCaseOptions"
        [placeholder]="t('useCasesPlaceholder')"
        [multiple]="true"
        [errorMessages]="errorMessagesService.messages()"
      ></htx-dropdown-field-with-error>
    </htx-form-section>
  </mat-dialog-content>

  <mat-dialog-actions class="form-dialog__actions" align="end">
    <htx-button variant="tertiary" size="small" (buttonClick)="cancel()">
      {{ t('cancel') }}
    </htx-button>
    <htx-button variant="primary" size="small" [disabled]="form.invalid" (buttonClick)="save()">
      {{ t('submit') }}
    </htx-button>
  </mat-dialog-actions>
</ng-container>
